import AverageRatesModal from './AverageRatesModal'
export default AverageRatesModal